import { render, staticRenderFns } from "./SecurityAssignPermissions.vue?vue&type=template&id=cc529206&scoped=true"
import script from "./SecurityAssignPermissions.vue?vue&type=script&lang=js"
export * from "./SecurityAssignPermissions.vue?vue&type=script&lang=js"
import style0 from "./SecurityAssignPermissions.vue?vue&type=style&index=0&id=cc529206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc529206",
  null
  
)

export default component.exports